import apiClient from './config';
import { API_ENDPOINTS } from '../config/api';

// Obtener todos los doctores disponibles
export const getDoctoresDisponibles = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.DOCTOR.AVAILABLE);
    return response;
  } catch (error) {
    console.error('Error al obtener doctores disponibles:', error);
    throw error;
  }
};

// Obtener configuración de receta del doctor
export const getConfiguracionReceta = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.DOCTOR.CONFIG_RECIPE);
    console.log('Respuesta completa de configuración:', response);
    return response.data;
  } catch (error) {
    console.error('Error al obtener configuración de receta:', error);
    throw error;
  }
};

// Método alternativo para mantener retrocompatibilidad
export const obtenerConfiguracionReceta = async () => {
  return getConfiguracionReceta();
};

// Guardar configuración de receta
export const guardarConfiguracionReceta = async (configData) => {
  try {
    // Si es un objeto JSON, enviarlo como JSON
    const response = await apiClient.post(API_ENDPOINTS.DOCTOR.CONFIG_RECIPE, configData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error al guardar configuración de receta:', error);
    throw error;
  }
};

// Actualizar configuración de receta con archivos
export const actualizarConfiguracionReceta = async (formData) => {
  try {
    // Si formData incluye eliminarLogo, significa eliminar el logo
    if (formData.get('eliminarLogo') === 'true') {
      formData.append('logoReceta', 'null');
    }
    
    // Si formData incluye eliminarPlantillaPDF, significa eliminar la plantilla
    if (formData.get('eliminarPlantillaPDF') === 'true') {
      formData.append('plantillaPDF', 'null');
    }
    
    const response = await apiClient.post(API_ENDPOINTS.DOCTOR.CONFIG_RECIPE, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error al actualizar configuración de receta:', error);
    throw error;
  }
};

// Exportamos todos los métodos como un objeto para poder importarlos de manera más limpia
const doctorService = {
  getDoctoresDisponibles,
  getConfiguracionReceta,
  obtenerConfiguracionReceta,
  guardarConfiguracionReceta,
  actualizarConfiguracionReceta
};

export default doctorService;
